<template>
  <div class="testimonial-area bg-gray5 ptb-100 position-relative z-1">
    <div class="container">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">آراء عملائنا</span>
        <h2>ماذا يقول المشتركون عن خدماتنا؟</h2>
        <p>
          ثقة عملائنا هي سر نجاحنا. نسعى دائماً لتقديم أفضل تجربة بث ومتابعة بدون تقطيع.
        </p>
      </div>
    </div>

    <div class="container-fluid p-md-0 overflow-hidden">
      <Swiper
        :slidesPerView="1"
        :spaceBetween="50"
        :centeredSlides="false"
        :preventClicks="true"
        :loop="true"
        :autoplay="{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :breakpoints="{
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
          1600: {
            slidesPerView: 4.5,
          },
        }"
        :modules="modules"
        class="testomonial-slide"
      >
        <SwiperSlide v-for="testimonial in testimonials" :key="testimonial.id">
          <div :class="['testimonial-single-item', testimonial.className]">
            <ul class="ps-0 list-unstyled d-flex gap-1">
              <li v-for="star in 5" :key="star">
                <i class="ri-star-fill"></i>
              </li>
            </ul>
            <h3>{{ testimonial.name }}</h3>
            <p>{{ testimonial.description }}</p>
          </div>
        </SwiperSlide>
      </Swiper>

      <div
        class="d-flex justify-content-between align-items-center google-review flex-wrap"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        <div class="d-flex align-items-center">
          <img src="@/assets/images/google.png" alt="google" />
          <p>التقييم العام <span>4.9</span></p>
        </div>
        <RouterLink to="/pricing-plan" class="read-more text-grey-teal">
          <span>اشترك معنا الآن</span>
          <i class="ti ti-arrow-left"></i>
        </RouterLink>
      </div>
    </div>

    <img src="@/assets/images/shape-2.png" class="shape shape-2" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

export default defineComponent({
  name: "OurTestimonial",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          className: "",
          name: "أبو أحمد (ألمانيا)",
          description:
            "بصراحة السيرفر ممتاز جداً وثابت وقت المباريات الكبيرة، جربت سيرفرات كتير في أوروبا بس هذا أفضلهم من ناحية استقرار البث جودة 4K.",
        },
        {
          id: 2,
          className: "two",
          name: "محمد الإدلبى",
          description:
            "مكتبة الأفلام والمسلسلات يتم تحديثها بشكل يومي، والترجمة احترافية وممتازة. الدعم الفني سريع جداً والتفعيل تم خلال دقائق.",
        },
        {
          id: 3,
          className: "",
          name: "خالد (السويد)",
          description:
            "أهم شيء بالنسبة لي كان تشغيل السيرفر على شاشة التلفزيون الذكية، أرسلوا لي التطبيق المناسب وطريقة التشغيل كانت سهلة وسلسة للغاية.",
        },
        {
          id: 4,
          className: "two",
          name: "عمر (فرنسا)",
          description:
            "سرعة خرافية في التنقل بين القنوات، وقنوات الأطفال متنوعة وآمنة جداً للعائلة. أنصح بالتعامل معهم بشدة وبدون تردد.",
        },
        {
          id: 5,
          className: "",
          name: "سامر (النمسا)",
          description:
            "اشتراك رائع وتغطية شاملة لكل الدوريات العالمية، جودة البث تتكيف تلقائياً مع سرعة الإنترنت عندي بدون أي تعليق أو تقطيع.",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
});
</script>